import "./Login.css";
import img from "../../img/bgimg.png";
import logo from "../../img/Logo.png";

export default function LoginView({
                                      handleClick,
                                      handlePasswordInput,
                                      handleEmailInput,
                                      forgotPassword,
                                      email,
                                      password
                                  }){

    return (
        <div className={"loginBackgroundContainer"}>

                <img className={"bgimg"}  src={img}/>
            <div className={"loginContainer"}>
                <img src={logo}/>
                <h1>Login</h1>
                <br/>
                <input style={{width: "100%"}} type="email" value={email} onChange={handleEmailInput} placeholder={"Email"}/>
                <br/>
                <br/>
                <input type="password" style={{width: "100%"}} value={password} onChange={handlePasswordInput} placeholder={"Passwort"}/>
                <br/><br/>
                <button className={"forgotpassword"} onClick={forgotPassword}>
                    Passwort vergessen
                </button>
                <br/>
                <button className={"button primarybutton"} onClick={handleClick}>
                    Login
                </button>
                {/*    formular reagiert auf enter button nicht todo*/}
                <br/>
            </div>
        </div>
    );
}

